var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React, { Children } from "react";
import { Row, Col } from "@riseart/antd-provider";
import { footerSectionCls } from "./Footer.less";
var FooterSection = /* @__PURE__ */ __name(function FooterSection2(_ref) {
  var children = _ref.children;
  var totalChildren = Children.count(children);
  return totalChildren === 1 ? /* @__PURE__ */ React.createElement("div", {
    className: footerSectionCls
  }, children) : /* @__PURE__ */ React.createElement(Row, {
    type: "flex",
    justify: "space-between",
    align: "top",
    className: footerSectionCls
  }, Children.map(children, function(child, index) {
    return /* @__PURE__ */ React.createElement(Col, {
      xs: 24,
      lg: index % 2 ? 5 : 18
    }, child);
  }));
}, "FooterSection");
export {
  FooterSection
};
